import { JSX, memo } from "react";
import { WorkingSessionImage } from "../../../../../common/types";
import { PhotoView } from "react-photo-view";

import "./styles.scss";

interface WorkSessionImageProps {
    data: WorkingSessionImage;
}

const WorkSessionImage = ({ data }: WorkSessionImageProps): JSX.Element => (
    <figure className="work-session-image-root">
        <PhotoView src={data.imagePath}>
            <img src={data.imagePath} alt={data?.description} />
        </PhotoView>
    </figure>
);

export default memo(WorkSessionImage);